import React, { useState, useEffect } from 'react';
import NavBar from '../Components/NavBar';
import HeroSection from '../Components/HeroSection';
import Box from '@mui/material/Box';
import About from '../Components/About';
import Services from '../Components/Services';
import Contact from '../Components/Contact';
import '../i18n';
import { useTranslation } from 'react-i18next';

function HomePage() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
console.log(t);
console.log(i18n);


  useEffect(() => {
    i18n.changeLanguage(language);  
  }, [language]);

  return (
    <Box
      sx={{
        backgroundColor: '#fdfdfd',
        overflow: 'hidden',
      }}
    >
      <NavBar
        className="somar-medium-bold"  
        setLanguage={setLanguage}
        t={t}
      />
      <HeroSection language={language} t={t} />
      <About language={language} t={t} />
      <Services language={language} t={t}/>
      <Contact language={language} t={t} />
    </Box>
  );
}

export default HomePage;
